import NextSection from "@components/About/NextSection";
import cx from "classnames";
import styles from "./Stories.module.scss";
import Item from "./Item";
// import { useTranslationContext } from "@providers/TranslationProvider";
import _ from "lodash";

export default function Stories({ data }: any) {
  // const { i18n } = useTranslationContext();
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <NextSection className={cx(styles.nextSection)}>
        <div className={cx(styles.titleSection)}>{_.get(data, "title")}</div>
      </NextSection>
      <div className={cx(styles.subtitleSection)}>{_.get(data, "content")}</div>
      <div className={cx(styles.wrapperItems)}>
        {_.map(_.get(data, "articles"), (item, index) => (
          <Item key={index} data={item} />
        ))}
      </div>
    </div>
  );
}
